// @flow
import React from 'react';
import { IconFilterItem } from 'components/atoms/iconFilterItem';
import type { NeighbourhoodTypes } from 'types/project';
import type { PropertyTypeOption } from 'types/filter';
// eslint-disable-next-line

type Props = {
  options: Array<NeighbourhoodTypes>,
  toggleFilter: () => void,
  activeFilter: Object<NeighbourhoodTypes>,
};

export const NeighbourhoodFilter = (props: Props) => {
  const { options, toggleFilter, activeFilter } = props;

  return (
    <div className={'filter-options'}>
      {options.map(option => {
        return (
          <IconFilterItem
            key={option.id}
            title={option.title}
            imageSrc={
              option.isActive ? option.activeImgSrc : option.imageSource
            }
            onClick={() => toggleFilter(option)}
            isActive={option.isActive}
          />
        );
      })}
    </div>
  );
};
